import React, { useState } from 'react';
export const RadioButton = ({
  id,
  name,
  label,
  checked,
  onChange,
  disabled = false,
  className = '',
  premium = false
}) => {
  const [isFocused, setIsFocused] = useState(false);
  return <label htmlFor={id} className={`flex items-start group cursor-pointer ${className} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`} data-id="element-483">
      <div className="flex items-center h-5 relative" data-id="element-484">
        <input id={id} name={name} type="radio" checked={checked} onChange={onChange} disabled={disabled} className="sr-only" onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} data-id="element-485" />
        <div className={`h-5 w-5 min-w-[20px] rounded-full transition-all duration-200
            ${checked ? 'border-2 border-[#111010]' : isFocused ? 'border-2 border-[#FCCA86]' : 'border border-gray-400 group-hover:border-[#FCCA86]'}`} data-id="element-486">
          {checked && <div className="h-2.5 w-2.5 bg-[#111010] m-[3px] rounded-full animate-scale-in" data-id="element-487"></div>}
        </div>
      </div>
      <div className="ml-2.5 text-sm" data-id="element-488">
        <span className="font-medium text-gray-800 text-[13px] leading-tight" data-id="element-489">
          {label}
        </span>
      </div>
    </label>;
};